import React, { Dispatch, SetStateAction, useState, type JSX } from 'react';
import ModalSingleInput from '@components/ModalSingleInput';
import { useWishlist } from '@context/businessContainer';
import List from '@monofront/design-system/visuals/Icons/Old/List';
import { useTranslations } from 'next-intl';

interface ICreateWishlistModalProps {
  triggerButtonRender: (
    setIsCreateWishlistModalOpen: Dispatch<SetStateAction<boolean>>,
  ) => JSX.Element;
}

const CreateWishlistModal: React.FC<ICreateWishlistModalProps> = ({
  triggerButtonRender,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { createWishlist } = useWishlist();

  const handleSubmit = async ({
    inputValue: wishlistName,
  }: Record<string, any>) => {
    await createWishlist(wishlistName);
  };

  const tWishlists = useTranslations('Wishlists');
  const tGlobal = useTranslations('Global');
  const tErrors = useTranslations('Errors');

  return (
    <>
      {triggerButtonRender(setIsOpen)}
      {isOpen && (
        <ModalSingleInput
          isModalOpen={isOpen}
          setIsModalOpen={setIsOpen}
          buttonLabel={tGlobal('ok').toUpperCase()}
          cancelButtonLabel={tGlobal('cancel')}
          inputPlaceholder={tGlobal('example', {
            example: tWishlists('myList'),
          })}
          submitHandler={handleSubmit}
          toastSuccessMessage={tWishlists('listCreated')}
          toastErrorMessage={tErrors('listCreationError')}
          modalTitle={
            <div className="title-modal">
              <List />
              <p>{tWishlists('newList')}</p>
            </div>
          }
        />
      )}
      <style jsx>{`
        .title-modal {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        }

        .title-modal > p {
          margin: var(--space-2) 0 var(--space-3) 0;
          font-weight: var(--font-weight-base);
        }
      `}</style>
    </>
  );
};

export default CreateWishlistModal;
